import { valueAccessor } from '@syncfusion/ej2-react-grids'
import React, { useCallback } from 'react'
import { connect } from 'react-redux'
import { addListItem, changeListItem, deleteListItem, getMixedListValues, nullDate, TDate, getListFromValues, getListItems } from '../../public/utility'
import { hasChangedValues, getFormValue, changeItemsValue } from '../../public/utility/formValues'
import CostBearingDepartmentDiv from './CostBearingDepartmentDiv'
import AdvanceApplicationSelectDiv from './AdvanceApplicationSelectDiv'
import ExpenseDetailDiv from './ExpenseDetailDiv'
import BTExpenseDtailDiv from './BTExpenseDtailDiv'
import InvoiceDiv from './InvoiceDiv'
import EntrustedTestContractSelectDiv from './EntrustedTestContractSelectDiv'
import AdvanceOrder from './AdvanceOrder'
import { exportFile } from 'tyan/public/index'
import SelectPurchaseOrderNoDiv from './SelectPurchaseOrderNoDiv'
import SelectOutApplyNumberDiv from './SelectOutApplyNumberDiv'
import RequisitionBatchDiv from 'tyan/menus/PurchaseManageMent/RequisitionBatchDiv'
import RequisitionDiv from 'tyan/menus/PurchaseManageMent/RequisitionDiv'
import LeaveApplyDetail from 'tyan/menus/LeaveManageMent/LeaveApplyDetail'
import FlowRecordDetail from '../OAManagement/FlowRecordDetail'

class ExpenseOrder extends React.Component {
	state = {
		changedValues基本信息: {},
	}

	SettingsDiv = {
		'成本承担部门': CostBearingDepartmentDiv,
		'预支申请单': AdvanceApplicationSelectDiv,
		'费用明细': ExpenseDetailDiv,
		'发票明细': InvoiceDiv,
		'委外测试合同': EntrustedTestContractSelectDiv,
		'出差/外训费用明细': BTExpenseDtailDiv,
	}

	componentDidMount = () => {
		this.handlerInitValue(this.props.id)
	}

	componentWillUnmount = () => {
		this.unmount = true
	}

	handlerInitValue = (id) => {
		const { taskName, expenseName } = this.props
		const 预支金额 = getFormValue(this, '基本信息', '预支金额')
		Tyan.doPostEvent({
			event: 'GetExpenseOrder',
			data: { id, taskName, expenseName },
			onEnd: ({ errorMessage, initValues基本信息, 部门, optionsParas }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					this.setState({ id, initValues基本信息, changedValues基本信息: {}, 部门, optionsParas })
				}
			}
		})
	}

	handlerSave = (classID = 0, name = '') => {
		const { readOnly, expenseName } = this.props
		const { id, changedValues基本信息 } = this.state
		const 报支名称 = getFormValue(this, '基本信息', '报支名称')
		const 报支类别 = getFormValue(this, '基本信息', '报支类别')
		const 状态 = getFormValue(this, '基本信息', '状态')
		var item = []
		if (报支名称 == '采购报支单') item = ['报支人', '采购单号', '付款方式', '付款期限', '报支类别', '供应商名称', '客户名称', '员工姓名']
		if (报支名称 == '一般报支单') item = ['报支人', '付款方式', '付款期限', '报支类别', '供应商名称', '客户名称', '员工姓名']
		if (报支名称 == '福利金报支单') item = ['报支人', '付款方式', '申请用途']
		if (报支名称 == '出差/外训报支单') item = ['币别', '报支人', '付款方式', '付款期限']
		if (报支名称 == '交际费报支单') item = ['币别', '报支人', '付款方式', '供应商或客户']
		if (报支名称 == '委外测试费报支单') item = ['币别', '报支人', '付款方式', '付款期限', '委外单位']
		for (var i = 0; i < item.length; i++) {
			if (item[i] == '供应商名称' && 报支类别 !== '供应商') continue
			if (item[i] == '客户名称' && 报支类别 !== '客户') continue
			if (item[i] == '员工姓名' && 报支类别 !== '员工') continue
			if (!getFormValue(this, '基本信息', item[i])) {
				Ext.toast(`${item[i]}必填`)
				return
			}
		}
		if (this.bChanged() && 状态 == '申请中')
			Tyan.doPostEvent({
				event: 'SaveExpenseOrder',
				data: { id, changedValues基本信息, expenseName },
				onEnd: ({ errorMessage, id }) => {
					if (errorMessage) {
						Tyan.pubForm.showError(errorMessage)
					}
					else {
						Ext.toast('保存成功')
						this.handlerInitValue(id)
						if (name !== '') {
							const Comp = this.SettingsDiv[name]
							Tyan.pubForm.showDialog(name, props => <Comp {...props} readOnly={readOnly || 状态 !== '申请中'} id={classID} advanceExpenseID={id} onSave={() => this.handlerInitValue(id)} />)
						}
					}
				}
			})
		else {
			if (name !== '') {
				const Comp = this.SettingsDiv[name]
				Tyan.pubForm.showDialog(name, props => <Comp {...props} readOnly={readOnly || 状态 !== '申请中'} id={classID} advanceExpenseID={id} onSave={() => this.handlerInitValue(id)} />)
			}
		}
	}

	handlerClose = () => {
		const { onClose } = this.props
		if (!this.bChanged()) {
			onClose && onClose()
			return
		}
		Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
	}

	handlerDelete = () => {
		const { id } = this.state
		const { onSave, onClose } = this.props
		Tyan.pubForm.showConfirm('确定要删除？', () =>
			Tyan.doPostEvent({
				event: 'DeleteExpenseOrder',
				data: { id },
				onEnd: ({ errorMessage }) => {
					if (errorMessage) {
						Tyan.pubForm.showError(errorMessage)
					}
					else {
						Ext.toast('删除成功')
						onSave && onSave()
						onClose && onClose()
					}
				}
			}))
	}

	handlerDeleteSelectAdvance = (advanceID) => {
		const { id } = this.state
		Tyan.doPostEvent({
			event: 'DeleteSelectAdvance',
			data: { advanceID, id },
			onEnd: ({ errorMessage }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					Ext.toast('删除成功')
					this.handlerInitValue(id)
				}
			}
		})
	}

	handlerDeleteEntrustedTestContractSelect = (contractID) => {
		const { id } = this.state
		Tyan.doPostEvent({
			event: 'DeleteEntrustedTestContractSelect',
			data: { contractID, id },
			onEnd: ({ errorMessage }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					Ext.toast('删除成功')
					this.handlerInitValue(id)
				}
			}
		})
	}

	bChanged = () => {
		return hasChangedValues(this)
	}

	canSave = () => {
		var bSave = false
		const 报支名称 = getFormValue(this, '基本信息', '报支名称')
		if (报支名称 == '交际费报支单')
			bSave = getFormValue(this, '基本信息', '供应商或客户')
		else if (报支名称 == '福利金报支单')
			bSave = getFormValue(this, '基本信息', '申请用途')
		else if (报支名称 == '委外测试费报支单') {
			bSave = getFormValue(this, '基本信息', '委外单位') && getFormValue(this, '基本信息', '开票公司') &&
				getFormValue(this, '基本信息', '发票明细') && getFormValue(this, '基本信息', '发票明细').length > 0
		}
		else if (报支名称 == '采购报支单' || 报支名称 == '一般报支单') {
			const 报支类别 = getFormValue(this, '基本信息', '报支类别')
			bSave = getFormValue(this, '基本信息', '报支类别')
			if (报支类别 == '员工') {
				bSave = bSave && getFormValue(this, '基本信息', '员工姓名')
			}
			if (报支类别 == '供应商') {
				bSave = bSave && getFormValue(this, '基本信息', '供应商名称')
			}
			if (报支类别 == '客户') {
				bSave = bSave && getFormValue(this, '基本信息', '客户名称')
			}
			if (报支名称 == '采购报支单' && bSave) {
				bSave = getFormValue(this, '基本信息', '采购单号') &&
					getFormValue(this, '基本信息', '发票明细') && getFormValue(this, '基本信息', '发票明细').length > 0
			}
		}
		else if (报支名称 == '出差/外训报支单')
			bSave = getFormValue(this, '基本信息', '请假申请单号')
		if (报支名称 !== '福利金报支单' && bSave)
			bSave = getFormValue(this, '基本信息', '付款期限')
		// if (报支名称 != '委外测试费报支单' && bSave)
		//     bSave = getFormValue(this, '基本信息', '报支金额')
		if (报支名称 == '出差/外训报支单' || 报支名称 == '交际费报支单')
			return getFormValue(this, '基本信息', '币别') &&
				getFormValue(this, '基本信息', '报支人') &&
				getFormValue(this, '基本信息', '付款方式') && getFormValue(this, '基本信息', '用途说明') &&
				getFormValue(this, '基本信息', '附件') && getFormValue(this, '基本信息', '附件').length > 0 && bSave
		else return getFormValue(this, '基本信息', '币别') &&
			getFormValue(this, '基本信息', '报支人') &&
			getFormValue(this, '基本信息', '付款方式') && getFormValue(this, '基本信息', '用途说明') &&
			getFormValue(this, '基本信息', '附件') && getFormValue(this, '基本信息', '附件').length > 0 && bSave
	}

	handleRelatedPersonChange = (v) => {
		const { optionsParas } = this.state
		changeItemsValue(this, '基本信息', ['报支部门'], [optionsParas[v]])
		const 报支名称 = getFormValue(this, '基本信息', '报支名称')
		if (报支名称 == '出差/外训报支单') {
			Tyan.doPostEvent({
				event: 'GetOutApplyNumber',
				data: { 报支人: v },
				onEnd: ({ errorMessage, optionsParas: newOptionsParas }) => {
					if (errorMessage) {
						Tyan.pubForm.showError(errorMessage)
					}
					else {
						this.setState({ optionsParas: { ...optionsParas, ...newOptionsParas } })
						this.handleGetBankInfo()
					}
				}
			})
		} else {
			const 报支类别 = getFormValue(this, '基本信息', '报支类别')
			if (报支类别 == '员工' && 报支名称 == '一般报支单')
				changeItemsValue(this, '基本信息', ['员工姓名'], [v])
			if (报支名称 !== '采购报支单')
				this.handleGetBankInfo()
		}
	}

	handleGetOptionsParas = (type, id, v) => {
		const { optionsParas } = this.state
		Tyan.doPostEvent({
			event: 'GetOptionsParas',
			data: { type, id, v },
			onEnd: ({ errorMessage, optionsParas: newOptionsParas, model }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					this.setState({ optionsParas: { ...optionsParas, ...newOptionsParas } })
					this.handleGetBankInfo()
				}
			}
		})
	}

	handleGetBankInfo = () => {
		const 报支名称 = getFormValue(this, '基本信息', '报支名称')
		var person = ''
		var supplier = ''
		var customer = ''
		if (报支名称 == '委外测试费报支单')
			supplier = getFormValue(this, '基本信息', '委外单位')
		else {
			if (报支名称 == '采购报支单' || 报支名称 == '一般报支单') {
				const 报支类别 = getFormValue(this, '基本信息', '报支类别')
				if (报支类别 == '员工')
					person = getFormValue(this, '基本信息', '员工姓名')

				else if (报支类别 == '供应商')
					supplier = getFormValue(this, '基本信息', '供应商名称')

				else if (报支类别 == '客户')
					customer = getFormValue(this, '基本信息', '客户名称')
			} else
				person = getFormValue(this, '基本信息', '报支人')
		}

		Tyan.doPostEvent({
			event: 'GetBankInfo',
			data: { person, supplier, customer },
			onEnd: ({ errorMessage, bankInfo }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					changeItemsValue(this, '基本信息', ['银行账号', '开户银行', '电话', '手机', '邮箱'], [bankInfo.银行账号, bankInfo.开户银行, bankInfo.电话, bankInfo.手机, bankInfo.邮箱])
					if (supplier != '')
						changeItemsValue(this, '基本信息', ['付款期限'], [bankInfo.付款条件])
				}
			}
		})
	}

	handleAdvanceAmountChange = (v) => {
		const 预支金额 = getFormValue(this, '基本信息', '预支金额')
		changeItemsValue(this, '基本信息', ['支付金额'], [v - 预支金额])
		this.AutoCalculation()
	}

	handleAdvanceType = (v, id) => {
		const { expenseName } = this.props
		const { optionsParas } = this.state
		const 名称 = getFormValue(this, '基本信息', '名称')
		const 报支名称 = getFormValue(this, '基本信息', '报支名称')
		const 报支类别 = getFormValue(this, '基本信息', '报支类别')
		const 员工姓名 = getFormValue(this, '基本信息', '员工姓名')

		Tyan.doPostEvent({
			event: 'GetExpenseBank',
			data: { expenseName, 报支类别: 报支类别, 名称: 名称, 报支名称, 员工姓名 },
			onEnd: ({ errorMessage, bankInfo, options }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					changeItemsValue(this, '基本信息', ['开户银行'], [bankInfo.开户银行])
					changeItemsValue(this, '基本信息', ['银行账号'], [bankInfo.银行账号])
					this.setState({ optionsParas: { ...optionsParas, '名称': options } })
				}
			}
		})
	}

	handleAccountBank = (v, 报支名称) => {
		const { expenseName } = this.props
		const 报支类别 = getFormValue(this, '基本信息', '报支类别')

		Tyan.doPostEvent({
			event: 'GetExpenseBank',
			data: { 名称: v, expenseName, 报支类别: 报支类别, 报支名称 },
			onEnd: ({ errorMessage, bankInfo, initValues基本信息, optionsParas }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					changeItemsValue(this, '基本信息', ['开户银行'], [bankInfo.开户银行])
					changeItemsValue(this, '基本信息', ['银行账号'], [bankInfo.银行账号])
				}
			}
		})
	}

	handleCurrencyNameChange = (v) => {
		const 申请时间 = getFormValue(this, '基本信息', '申请时间')
		Tyan.doPostEvent({
			event: 'GetExchangeRateByCurrency',
			data: { 币别: v, 申请时间 },
			onEnd: ({ errorMessage, ExchangeRate }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					changeItemsValue(this, '基本信息', ['汇率'], [ExchangeRate])
					this.AutoCalculation()
				}
			}
		})
	}

	handlerExpenseExport = () => {
		const { id } = this.state
		exportFile(null, null, "ExpenseExport?id=" + id)
	}

	handleSelectOrderNoDiv = (initValues, onConfirm, onDelete) => {
		Tyan.pubForm.showDialog(initValues.title, props => <SelectPurchaseOrderNoDiv {...props} initValues={initValues} onConfirm={onConfirm} onDelete={onDelete} />)
	}

	handleOutApplyNumberDiv = (initValues, onConfirm, onDelete) => {
		Tyan.pubForm.showDialog(initValues.title, props => <SelectOutApplyNumberDiv {...props} relatedPerson={initValues.报支人} initValues={initValues} onConfirm={onConfirm} onDelete={onDelete} />)
	}

	handleSelectedChanged = (name, value) => {
		changeItemsValue(this, '基本信息',
			[name],
			[value],
		)
	}

	// handlerGetRequisition = () => {
	//     const 请购单号 = getFormValue(this, '基本信息', `采购单号`)
	//     Tyan.doPostEvent({
	//         event: 'GetRequisitionID',
	//         data: { 请购单号 },
	//         onEnd: ({ errorMessage, ids }) => {
	//             if (errorMessage) {
	//                 Tyan.pubForm.showError(errorMessage)
	//             }
	//             if (ids.length > 1) {
	//                 Tyan.pubForm.showDialog('采购信息', props => <RequisitionBatchDiv {...props} ids={ids} />)
	//             }
	//             else {
	//                 Tyan.pubForm.showDialog('采购信息', props => <RequisitionDiv {...props} id={ids[0]} />)
	//             }
	//         }
	//     })
	// }

	handlerGetLeaveApplyDetail = (outReason) => {
		const 申请编号 = getFormValue(this, '基本信息', `请假申请单号`)
		if (outReason == '外训')
			Tyan.doPostEvent({
				event: 'GetOutTrainDetail',
				data: { 申请编号 },
				onEnd: ({ errorMessage, id }) => {
					if (errorMessage) {
						Tyan.pubForm.showError(errorMessage)
					}
					Tyan.pubForm.showDialog('外训申请单', props => <FlowRecordDetail {...props} id={id} type={'show'} />)
				}
			})
		else
			Tyan.doPostEvent({
				event: 'GetLeaveApplyDetail',
				data: { 申请编号 },
				onEnd: ({ errorMessage, id }) => {
					if (errorMessage) {
						Tyan.pubForm.showError(errorMessage)
					}
					Tyan.pubForm.showDialog('请假申请单', props => <LeaveApplyDetail {...props} id={id} notSubmit={true} />)
				}
			})
	}

	fieldset基本信息 = () => {
		const { readOnly } = this.props
		const { optionsParas } = this.state
		const { 部门 } = this.state
		const 状态 = getFormValue(this, '基本信息', '状态')
		const 报支类别 = getFormValue(this, '基本信息', '报支类别')
		const 报支名称 = getFormValue(this, '基本信息', '报支名称')
		const 采购单号 = getFormValue(this, '基本信息', '采购单号')
		const 预支金额 = getFormValue(this, '基本信息', '预支金额')
		const 委托总和 = getFormValue(this, '基本信息', '委托总和')
		const 报支人 = getFormValue(this, '基本信息', '报支人')
		const { list } = getListItems(this, '基本信息', '成本承担部门')
		const { list: list1 } = getListItems(this, '基本信息', '费用明细')
		const { list: list2 } = getListItems(this, '基本信息', '发票明细')
		const { list: list3 } = getListItems(this, '基本信息', '出差费用明细')
		const 请购单号 = getFormValue(this, '基本信息', `采购单号`)
		const 请假单号 = getFormValue(this, '基本信息', `请假申请单号`)
		const 外出原因 = getFormValue(this, '基本信息', `外出原因`)
		const 交际对象 = getFormValue(this, '基本信息', `交际对象`)
		const { list: list4 } = getListItems(this, '基本信息', '委外测试合同')

		var fields = [

		]

		var top = [
			{ _text: '报支单号', minWidth: '45%', disabled: true },
			{ _datetime: '申请时间', minWidth: '45%', disabled: true, },
		]
		if (报支名称 == '委外测试费报支单')
			top.push(top.push({ _select: '成本单位', name: '开票公司', minWidth: '95%', required: true, disabled: 委托总和 || list4.length > 0, }))
		top.push({ _text: '申请人', minWidth: '45%', disabled: true })
		top.push({ _text: '申请部门', minWidth: '45%', disabled: true })
		var body = [
		]
		var bottom = [
		]
		var follow = [
		]
		if (报支名称 == '采购报支单' || 报支名称 == '一般报支单') {
			top.push({ _select: '报支人', minWidth: '45%', editable: true, required: true, onChange: (v) => this.handleRelatedPersonChange(v), disabled: 预支金额 && 报支类别 == '员工' })
			top.push({ _text: '报支部门', minWidth: '45%', disabled: true, })
			//采购报支单-采购多选切打开采购单，8/26
			if (报支名称 == '采购报支单')
				top.push({
					_group: '', minWidth: '90%', margin: 0, items: [
						{
							_text: '采购单号', required: true, disabled: true, minWidth: '20%', tooltip: 请购单号,
							button: { text: "...", handler: (orderNo) => this.handleSelectOrderNoDiv({ title: '选择采购单号', orderNo, bReadOnly: readOnly || 状态 !== '申请中' }, (orderNo) => this.handleSelectedChanged('采购单号', orderNo)) }
						},
						// {
						//     _buttons: [
						//         {
						//             _button: '查看', icon: 'info-circle', ui: '', margin: 0,
						//             handler: () => this.handlerGetRequisition(), disabled: !请购单号 || 请购单号 == '',
						//         },
						//     ], width: 100, margin: 0,
						// },
					]
				})

			body.push({ _select: '币别', minWidth: '45%', onChange: (v) => this.handleCurrencyNameChange(v), disabled: 预支金额 })
			body.push({ _float: '汇率', minWidth: '45%', disabled: true, decimals: 4 })
			body.push({ _float: '报支金额', minWidth: '90%', onChange: (v) => this.handleAdvanceAmountChange(v), textAlign: 'left', })
			body.push({ _float: '预支金额', minWidth: '90%', disabled: true, textAlign: 'left', })
			body.push({ _float: '支付金额', minWidth: '90%', disabled: true, textAlign: 'left', })
			body.push({ _text: '用途说明', minWidth: '90%', maxRows: 4, required: true })

			bottom.push({ _select: '付款方式', minWidth: '45%', required: true })
			bottom.push({ _select: '付款条件', name: '付款期限', minWidth: '45%', required: true, disabled: readOnly || 状态 !== '申请中' || 报支类别 == '供应商' })
			bottom.push({ _select: '报支类别', minWidth: '45%', disabled: 预支金额, onChange: (v) => this.handleAdvanceType(v, this.props.id) })
			// fields.push({ _radio: '安环费用支出', minWidth: '45%', })
			if (报支类别 == '员工') {
				bottom.push({ _select: '员工姓名', minWidth: '45%', required: true, disabled: 预支金额, editable: true, forceSelection: false, onChange: (v) => this.handleGetOptionsParas('员工姓名', this.props.id, v) })
			}
			if (报支类别 == '供应商') {
				bottom.push({ _select: '供应商名称', minWidth: '45%', required: true, disabled: 预支金额, editable: true, forceSelection: false, onChange: (v) => this.handleGetOptionsParas('供应商名称', this.props.id, v) })
			}
			if (报支类别 == '客户') {
				bottom.push({ _select: '客户名称', minWidth: '45%', required: true, disabled: 预支金额, editable: true, forceSelection: false, onChange: (v) => this.handleGetOptionsParas('客户名称', this.props.id, v) })
			}
			bottom.push({ _select: '名称', name: '名称', minWidth: '45%', editable: true, forceSelection: false, cdt: () => 报支名称 == "一般报支单" && 报支类别 == "其他", onChange: (v) => this.handleAccountBank(v, 报支名称) })
			bottom.push({ _text: '开户银行', minWidth: '45%', })
			bottom.push({ _text: '银行账号', minWidth: '45%', })
			// fields.push({ _radio: '采购类型', minWidth: '45%', })

			bottom.push({ _files: '附件', minWidth: '90%', required: true })

			if (报支名称 == '采购报支单') {
				follow.push({ _label: '发票明细 <font style=\'color:red;\'>*</font>', minWidth: '95%', margin: 0 })
				follow.push({
					_grid: '', name: '发票明细', rowNumbers: true, minRows: 2, maxRows: 999, minWidth: '95%', margin: 0,
					summary: true,
					columns: [
						{ _text: '发票号码', flex: 2.5, summaryRenderer: () => '合计', summaryCell: { xtype: 'gridcell' } },
						{ _date: '发票日期', flex: 3 },
						{ _float: '原币含税金额', flex: 2.8, summary: 'sum' },
						// { _text: '税率', flex: 3.7 },
						{ _float: '原币未税金额', flex: 2.8 },
						{ _float: '本币含税金额', flex: 2.8 },
						{ _float: '本币未税金额', flex: 2.8 },
						{ _text: '备注', flex: 1.8 },

					],
					buttons: [
						{ _button: '添加...', /* icon: 'plus', */  handler: () => this.handlerSave(0, '发票明细'), cdt: () => !readOnly && 状态 == '申请中' },
					],
					onDoubleTap: data => this.handlerSave(data.id, '发票明细')
				})
			}
		}

		if (报支名称 == '福利金报支单') {
			top.push({ _select: '报支人', minWidth: '45%', editable: true, required: true, onChange: (v) => this.handleRelatedPersonChange(v), disabled: 预支金额, })
			top.push({ _text: '报支部门', minWidth: '45%', disabled: true })
			top.push({ _radio: '申请用途', minWidth: '90%', required: true })

			body.push({ _select: '币别', minWidth: '45%', onChange: (v) => this.handleCurrencyNameChange(v), disabled: 预支金额 })
			body.push({ _float: '汇率', minWidth: '45%', disabled: true, decimals: 4 })
			body.push({ _float: '报支金额', minWidth: '90%', onChange: (v) => this.handleAdvanceAmountChange(v), textAlign: 'left', })
			body.push({ _float: '预支金额', minWidth: '90%', disabled: true, textAlign: 'left', })
			body.push({ _float: '支付金额', minWidth: '90%', disabled: true, textAlign: 'left', })
			body.push({ _text: '用途说明', minWidth: '90%', maxRows: 4, required: true })

			bottom.push({ _select: '付款方式', minWidth: '45%', required: true })
			bottom.push({ _select: '付款条件', name: '付款期限', minWidth: '45%', required: true })
			bottom.push({ _text: '开户银行', minWidth: '45%', })
			bottom.push({ _text: '银行账号', minWidth: '45%', })
			bottom.push({ _files: '附件', minWidth: '90%', required: true })
		}
		if (报支名称 == '出差/外训报支单') {
			top.push({ _select: '报支人', minWidth: '45%', editable: true, required: true, onChange: (v) => this.handleRelatedPersonChange(v), disabled: 预支金额, })
			top.push({ _text: '报支部门', minWidth: '45%', disabled: true })
			top.push({
				_group: '', minWidth: '90%', margin: 0, items: [
					{
						_text: '出差/外训申请单号', name: '请假申请单号', disabled: true, minWidth: '20%', required: true,
						button: { text: "...", handler: (outApplyNumber) => this.handleOutApplyNumberDiv({ title: '选择出差/外训申请单号', 报支人, outApplyNumber, bReadOnly: readOnly || 状态 !== '申请中' }, (outApplyNumber, outReason) => { this.handleSelectedChanged('请假申请单号', outApplyNumber), this.handleSelectedChanged('外出原因', outReason) }) }
					},
					// {
					//     _buttons: [
					//         {
					//             _button: '查看', icon: 'info-circle', ui: '', margin: 0,
					//             handler: () => this.handlerGetLeaveApplyDetail(外出原因), disabled: !请假单号 || 请假单号 == '',
					//         },
					//     ], width: 100, margin: 0,
					// },
				]
			})

			body.push({ _select: '币别', minWidth: '45%', onChange: (v) => this.handleCurrencyNameChange(v), disabled: 预支金额 })
			body.push({ _float: '汇率', minWidth: '45%', disabled: true, decimals: 4 })
			body.push({ _float: '报支金额', minWidth: '90%', disabled: true, textAlign: 'left', })
			body.push({ _float: '预支金额', minWidth: '90%', disabled: true, textAlign: 'left', })
			body.push({ _float: '支付金额', minWidth: '90%', disabled: true, textAlign: 'left', })
			body.push({ _text: '用途说明', minWidth: '90%', maxRows: 4, required: true })

			bottom.push({ _select: '付款方式', minWidth: '45%', required: true })
			bottom.push({ _select: '付款条件', name: '付款期限', minWidth: '45%', required: true })
			bottom.push({ _text: '开户银行', minWidth: '45%', })
			bottom.push({ _text: '银行账号', minWidth: '45%', })
			// fields.push({
			//     _text: '请假申请单号', disabled: true, minWidth: '45%',
			//     button: { text: "...", handler: () => this.handleOutApplyNumberDiv({ title: '选择请假申请单号', 报支人 }, (outApplyNumber) => this.handleSelectedChanged('请假申请单号', outApplyNumber)) }
			// })
			//fields.push({ _select: '请假申请单号', minWidth: '45%', })
			bottom.push({ _files: '附件', minWidth: '90%', required: true })
			follow.push({
				_grid: '出差/外训费用明细', name: '出差费用明细', rowNumbers: true, minRows: 2, maxRows: 999, minWidth: '95%',
				summary: true,
				columns: [
					{ _text: '起止日期', flex: 2, summaryRenderer: () => '合计', summaryCell: { xtype: 'gridcell' } },
					{ _text: '起止地点', flex: 2, },
					{ _float: '飞机票', flex: 1.7, summary: 'sum' },
					{ _float: '火车船票', flex: 2, summary: 'sum' },
					{ _float: '公交出租', flex: 2, summary: 'sum' },
					{ _float: '公里补助', flex: 2, summary: 'sum' },
					{ _float: '停车费', flex: 1.7, summary: 'sum' },
					{ _float: '膳食费', flex: 1.7, summary: 'sum' },
					{ _float: '住宿费', flex: 1.7, summary: 'sum' },
					{ _float: '其他', flex: 1.7, summary: 'sum' },
					{ _float: '合计', flex: 2, summary: 'sum' },
				],
				buttons: [
					{ _button: '添加...', /* icon: 'plus', */  handler: () => this.handlerSave(0, '出差/外训费用明细'), cdt: () => !readOnly && 状态 == '申请中' },
				],
				onDoubleTap: data => this.handlerSave(data.id, '出差/外训费用明细')
			})
		}
		if (报支名称 == '交际费报支单') {
			top.push({ _select: '报支人', minWidth: '45%', editable: true, required: true, onChange: (v) => this.handleRelatedPersonChange(v), disabled: 预支金额, })
			top.push({ _text: '报支部门', minWidth: '45%', disabled: true })

			body.push({ _select: '币别', minWidth: '45%', onChange: (v) => this.handleCurrencyNameChange(v), disabled: 预支金额 })
			body.push({ _float: '汇率', minWidth: '45%', disabled: true, decimals: 4 })
			body.push({ _float: '报支金额', minWidth: '90%', disabled: true, textAlign: 'left', })
			body.push({ _float: '预支金额', minWidth: '90%', disabled: true, textAlign: 'left', })
			body.push({ _float: '支付金额', minWidth: '90%', disabled: true, textAlign: 'left', })
			body.push({ _radio: '交际对象', minWidth: '45%', items: ['供应商', '客户'] })
			body.push({ _select: '供应商', name: '供应商或客户', options: optionsParas.供应商名称, minWidth: '45%', cdt: () => 交际对象 != '客户', required: true, editable: true, forceSelection: false, onChange: (v) => this.handleGetOptionsParas('供应商名称', this.props.id, v) })
			body.push({ _select: '客户名称', name: '供应商或客户', options: optionsParas.客户名称, minWidth: '45%', cdt: () => 交际对象 == '客户', required: true, editable: true, forceSelection: false, onChange: (v) => this.handleGetOptionsParas('客户名称', this.props.id, v) })
			body.push({ _select: '参加人员', minWidth: '90%', multiSelect: true, editable: true })
			body.push({ _number: '总人数', minWidth: '90%' })
			body.push({ _text: '用途说明', minWidth: '90%', maxRows: 4, required: true })

			bottom.push({ _select: '付款方式', minWidth: '45%', required: true })
			bottom.push({ _select: '付款条件', name: '付款期限', minWidth: '45%', required: true })
			bottom.push({ _text: '开户银行', minWidth: '45%', })
			bottom.push({ _text: '银行账号', minWidth: '45%', })
			bottom.push({ _files: '附件', minWidth: '90%', required: true })
			follow.push({
				_grid: '费用明细', name: '费用明细', rowNumbers: true, minRows: 2, maxRows: 999, minWidth: '95%',
				summary: true,
				columns: [
					{ _date: '日期', flex: 1, summaryRenderer: () => '合计', summaryCell: { xtype: 'gridcell' } },
					{ _text: '类别', flex: 1, },
					{ _float: '金额', flex: 1, },
					{ _text: '币别', flex: 1, onChange: (v) => this.handleCurrencyNameChange(v), disabled: 预支金额 },
					{ _float: '汇率', flex: 1, decimals: 4 },
					{ _float: '人民币金额', flex: 1, summary: 'sum' },
					{ _text: '备注', flex: 2 },
				],
				buttons: [
					{ _button: '添加...', /* icon: 'plus', */  handler: () => this.handlerSave(0, '费用明细'), cdt: () => !readOnly && 状态 == '申请中' },
				],
				onDoubleTap: data => this.handlerSave(data.id, '费用明细')
			})
		}
		if (报支名称 == '委外测试费报支单') {
			const { list: optionsList } = getListFromValues('部门', null, 部门, {})
			top.push({ _select: '报支人', minWidth: '45%', editable: true, required: true, onChange: (v) => this.handleRelatedPersonChange(v), disabled: 预支金额, })
			top.push({ _text: '报支部门', minWidth: '45%', disabled: true })
			top.push({ _html: '委外项目成本总和', name: '委外总和', minWidth: '45%', disabled: true, style: { color: 'darkgreen', fontWeight: 'bold' } })
			top.push({ _html: '委外项目收入总和', name: '合同总和', minWidth: '45%', disabled: true, style: { color: 'darkgreen', fontWeight: 'bold' } })

			body.push({ _select: '币别', minWidth: '45%', onChange: (v) => this.handleCurrencyNameChange(v) })
			body.push({ _float: '汇率', minWidth: '45%', disabled: true, decimals: 4 })
			body.push({ _float: '报支金额', minWidth: '90%', required: true, onChange: (v) => this.handleAdvanceAmountChange(v), textAlign: 'left', })
			body.push({ _float: '预支金额', minWidth: '90%', disabled: true, textAlign: 'left', })
			body.push({ _float: '支付金额', minWidth: '90%', disabled: true, textAlign: 'left', })
			body.push({ _text: '用途说明', minWidth: '90%', maxRows: 4, required: true })
			//委外测试费报支单中新增报支部门，8/25
			// fields.push({
			//     _treeselect: '报支部门', name: '报支部门', required: true, minWidth: '30%', displayField: '部门名称', options: optionsList,
			//     displayFull: '/', displayName: '报支部门', fullNameField: 'fullName', leafOnly: false, rootText: '',
			// },)

			bottom.push({ _select: '委外单位', minWidth: '90%', required: true, editable: true, forceSelection: false, disabled: 委托总和 || list4.length > 0, onChange: () => this.handleGetBankInfo() })
			bottom.push({ _select: '付款方式', minWidth: '45%', required: true })
			bottom.push({ _select: '付款条件', name: '付款期限', minWidth: '45%', required: true, disabled: true })
			bottom.push({ _text: '开户银行', minWidth: '45%', })
			bottom.push({ _text: '银行账号', minWidth: '45%', })
			bottom.push({ _files: '附件', minWidth: '90%', required: true })
			follow.push({ _label: '发票明细 <font style=\'color:red;\'>*</font>', minWidth: '95%', margin: 0 })
			follow.push({
				_grid: '', name: '发票明细', rowNumbers: true, minRows: 2, maxRows: 999, minWidth: '95%', margin: 0,
				summary: true,
				columns: [
					{ _text: '发票号码', flex: 2.5, summaryRenderer: () => '合计', summaryCell: { xtype: 'gridcell' } },
					{ _date: '发票日期', flex: 3 },
					{ _float: '原币含税金额', flex: 2.8, summary: 'sum' },
					// { _text: '税率', flex: 3.7 },
					{ _float: '原币未税金额', flex: 2.8 },
					{ _float: '本币含税金额', flex: 2.8 },
					{ _float: '本币未税金额', flex: 2.8 },
					{ _text: '备注', flex: 1.8 },
				],
				buttons: [
					{ _button: '添加...', /* icon: 'plus', */  handler: () => this.handlerSave(0, '发票明细'), cdt: () => !readOnly && 状态 == '申请中' },
				],
				onDoubleTap: data => this.handlerSave(data.id, '发票明细')
			})
		}
		follow.push({ _label: '成本承担部门', minWidth: '95%', margin: 0 })
		follow.push({
			_grid: '', name: '成本承担部门', rowNumbers: true, minRows: 1, maxRows: 999, minWidth: '95%', margin: 0,
			columns: [
				{ _text: '成本承担部门', flex: 4 },
				{ _float: '部门分摊金额', flex: 2 },
				{ _text: '部门分摊比例', flex: 2 },
			],
			buttons: [
				{ _button: '添加...', /* icon: 'plus', */  handler: () => this.handlerSave(0, '成本承担部门'), cdt: () => !readOnly && 状态 == '申请中' },
			],
			onDoubleTap: data => this.handlerSave(data.id, '成本承担部门')
		})

		fields.push({ _border: ' ', margin: '0px 5px 2px 5px', padding: '10px 10px 10px 10px', minWidth: '82%', items: top, })
		fields.push({ _border: ' ', margin: '2px 5px 2px 5px', padding: '10px 10px 10px 10px', minWidth: '82%', items: body, })
		fields.push({ _border: ' ', margin: '2px 5px 2px 5px', padding: '10px 10px 10px 10px', minWidth: '82%', items: bottom, })
		fields.push({ _group: ' ', margin: '2px 5px 2px 5px', padding: '10px 10px 10px 10px', minWidth: '82%', items: follow, })

		return fields
	}

	fieldset流转日志 = () => {
		return [
			{ _html: '', name: '流转日志', minWidth: '95%', style: { textAlign: 'left' } }]
	}

	fieldset签核流程 = () => {
		return [
			{ _html: '', name: '签核流程', minWidth: '95%', style: { textAlign: 'left' } }]
	}

	fieldset预支申请单 = () => {
		const { readOnly } = this.props
		const 状态 = getFormValue(this, '基本信息', '状态')
		return [
			{
				_grid: '', name: '预支申请单', rowNumbers: true, height: '100%', minWidth: '95%',
				columns: [
					{ _text: '预支申请单号', flex: 1.5 },
					{ _float: '预支金额', flex: 1 },
					{ _date: '申请日期', flex: 1.2 },
					{ _text: '申请人', flex: 1 },
					{ _text: '用途说明', flex: 1 },
					{
						_button: '', icon: 'trash-o', ui: 'decline', hidden: (data) => readOnly || 状态 !== '申请中',
						handler: (that, data, record) => Tyan.pubForm.showConfirm('确定要删除？', () => this.handlerDeleteSelectAdvance(data.id)),
						flex: 0.5
					},
				],
				buttons: [
					{ _button: '选择...', /* icon: 'plus', */  handler: () => this.handlerSave(0, '预支申请单'), cdt: () => !readOnly && 状态 == '申请中' },
				],
				onDoubleTap: data => Tyan.pubForm.showDialog('预支申请单', props => <AdvanceOrder {...props} id={data.id} readOnly={true} />)
			}
		]
	}

	fieldset委外测试合同 = () => {
		const { readOnly } = this.props
		const 状态 = getFormValue(this, '基本信息', '状态')
		return [
			{
				_grid: '', name: '委外测试合同', rowNumbers: true, height: '100%', minWidth: '90%',
				columns: [
					{ _text: '合同编号', flex: 2.3, minWidth: 150 },
					{ _text: '样品名称', flex: 1.5, minWidth: 100 },
					{ _text: '测试项目', flex: 1.5, minWidth: 150 },
					{ _text: '业务员', flex: 1.5, minWidth: 150 },
					{ _text: '委外项目成本', name: '委外金额', flex: 1.5, minWidth: 150 },
					{ _float: '委外项目收入', name: '合同金额', flex: 1.5, minWidth: 150 },
					{ _text: '税率', flex: 1.5, minWidth: 150 },
					{
						_button: ' ', icon: 'trash-o', ui: 'decline', hidden: (data) => readOnly || 状态 !== '申请中',
						handler: (that, data, record) => Tyan.pubForm.showConfirm('确定要删除？', () => this.handlerDeleteEntrustedTestContractSelect(data.id)),
						flex: 0.5
					},
				],
				buttons: !readOnly && 状态 == '申请中' && [
					{ _button: '选择...', /* icon: 'plus', */  handler: () => this.handlerSave(0, '委外测试合同') },
				],
			}
		]
	}

	render() {
		const { showMessage: Message, showBody: Body, readOnly } = this.props
		const { errorMessage, id, initValues基本信息, } = this.state
		if (errorMessage) return Tyan.pubForm.showError(errorMessage)
		if (!initValues基本信息) return <Message text={'请稍等 ...'} />
		const { 报支名称, 状态, 提交时间 } = initValues基本信息
		return <Body data={this} maxWidth="100%"
			controls={
				readOnly ? [
					{ _flow: 'ExpenseFlow', disabled: this.bChanged() || !this.canSave(), cdt: () => 状态 == '已完成', },
					{ _button: '打印', icon: 'print', handler: this.handlerExpenseExport, disabled: this.bChanged(), cdt: () => 状态 == '已完成' || 状态 == '报支确认' || 状态 == '金额支付' || 状态 == '报支打印' },
					{ _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
				] : [
					{ _flow: 'ExpenseFlow', disabled: this.bChanged() || !this.canSave(), cdt: () => id > 0, },
					// 1)改为只在报支单的状态名称为“报支打印”或“金额支付”或“报支确认”或“已完成”时显示
					{ _button: '打印', icon: 'print', handler: this.handlerExpenseExport, cdt: () => id > 0, disabled: this.bChanged(), cdt: () => 状态 == '已完成' || 状态 == '报支打印' || 状态 == '金额支付' || 状态 == '报支确认' },
					{ _button: '保存', icon: 'save', handler: () => this.handlerSave(), disabled: !(this.canSave() && this.bChanged()), cdt: () => 状态 == '申请中' },
					{ _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0 && 状态 == '申请中' && 提交时间 == nullDate, handler: this.handlerDelete, disabled: this.bChanged() },
					{ _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
				]}
			fieldsets={
				[
					{ title: 报支名称, name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: readOnly || 状态 !== '申请中' },
					{
						_fieldsets: [
							{ title: '流转日志', name: '基本信息', _fieldset: this.fieldset流转日志(), fullblock: true },
							{ title: '委外测试合同', name: '基本信息', _fieldset: this.fieldset委外测试合同(), fullblock: true, cdt: () => 报支名称 == '委外测试费报支单' },
							{ title: '预支申请单', name: '基本信息', _fieldset: this.fieldset预支申请单(), fullblock: true },
							{ title: '签核流程', name: '基本信息', _fieldset: this.fieldset签核流程(), fullblock: true },
						], docked: 'right', width: '40%',
					}
				]
			}
		/>
	}
}

export default connect()(ExpenseOrder)